<div class="boxFooter">
  <div>
    @if (!fullScreen) {
      <img (click)="toggleExpand()" class="expand-button" src="/assets/images/Expand.svg" />
    }
    @if (fullScreen) {
      <img (click)="toggleExpand()" class="expand-button" src="/assets/images/Collapse.svg" />
    }
  </div>
  <div class="longnames">
    <div id="configFullName">
      <div><strong>Full Config Name:</strong> {{ fullConfigName ?? '(not assigned)' }}</div>

      @if (fullConfigName) {
        <img
          (click)="copy(fullConfigName)"
          class="copyicon"
          src="/assets/svgs/copy.svg"
          style="height: 1.1875rem"
          title="Click to copy full config name for use in configs and sdks [{{ fullConfigName }}]"
          />
      }
    </div>
    <div id="configTypeFullName">
      <div><strong>Full Config Type Name:</strong> {{ fullConfigTypeName }}</div>
      @if (fullConfigTypeName) {
        <img
          (click)="copy(fullConfigTypeName)"
          class="copyicon"
          src="/assets/svgs/copy.svg"
          style="height: 1.1875rem"
          title="Click to copy full config type name for use in configs and sdks [{{ fullConfigTypeName }}]"
          />
      }
    </div>
  </div>
  <div>
    <div (click)="update()" class="button">
      <!--[matTooltipClass]="'tooltip update-disabled'"
      matTooltip="{{ fullScreen ? 'Cannot update config while in fullscreen mode' : '' }}"-->
      Save
    </div>
  </div>
</div>
